class AccountDialogComponent extends HTMLElement {
  connectedCallback() {
    this.innerHTML = String.raw`
    
    <div class="modal fade" id="modal-sign-up-form" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <h3>Create an account to unlock the full power of WebStructural</h3>
          </div>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th></th>
                  <th class="text-center">
                    <h4>Basic</h4>
                  </th>
                  <th class="text-center">
                    <h4>Pro</h4>
                  </th>
                </tr>
              </thead>
              <tbody>
                ${this.makeUpgradeFeatureRow("Save Projects", "fa-save")}
                ${this.makeUpgradeFeatureRow("Print Results", "fa-print")}
                ${this.makeUpgradeFeatureRow("Multiple Spans (more than 2)", "fa-ellipsis-h")}
                ${this.makeUpgradeFeatureRow("HSS Strong and Weak Axis Analysis", "fa-arrows")}
                ${this.makeUpgradeFeatureRow("European Steel Shape Analysis", "fa-globe")}
                ${this.makeUpgradeFeatureRow("Custom Shape Analysis", "fa-user")}
                ${this.makeUpgradeFeatureRow("Multi Ply Lumber", "fa-ellipsis-h")}
                ${this.makeUpgradeFeatureRow("LVL and PSL Engineered Lumber", "fa-calculator")}
              </tbody>
            </table>
          </div>

          <div id="modal-sign-up-error" class="alert alert-danger d-none"></div>
          
          <form role="form">

            <div class="input-group mb-3">
              <span class="input-group-text"><i class="fa fa-user"></i></span>
              <input class="form-control" placeholder="Name" name="name" type="name" id="sign-up-first-last">
            </div>

            <div class="input-group mb-3">
              <span class="input-group-text"><i class="fa fa-envelope"></i></span>
              <input class="form-control" placeholder="you@example.com" name="email" type="email" autocomplete="email" id="sign-up-email">
            </div>

            <div class="input-group mb-3">
              <span class="input-group-text"><i class="fa fa-lock color-blue"></i></span>
              <input class="form-control" placeholder="Password" name="password" type="password" autocomplete="new-password" id="sign-up-password">
            </div>

            <div class="mb-3">
              <div class="d-grid gap-2  mx-auto">
                <a href="#" class="btn btn-lg btn-primary button-shadow" onclick="signup();"><span id="sign-up-wait-spinner" class="d-none">
                  <i class="fa fa-spinner fa-spin"></i></span>Sign Up
                </a>
                <a href="#" class="btn btn-sm btn-default button-shadow text-small" data-bs-dismiss="modal" onclick="openSigninModal();">
                  Already have an account? Login
                </a>
                <a href="eula.html" target="_blank" class="text-center text-muted text-small">
                  By creating an account you agree to our Terms of Service
                </a>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modal-login-form" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <h2><i class="fa-solid fa-right-to-bracket" style="font-size: 3rem;"></i></h2>
            <h2 class="text-center">Sign In</h2>
          </div>
          <div id="modal-sign-in-error" class="alert alert-danger d-none"></div>
          <form role="form">

            <div class="input-group mb-3">
              <span class="input-group-text"><i class="fa fa-envelope"></i></span>
              <input class="form-control" placeholder="you@example.com" name="email" type="email" autocomplete="email" id="sign-in-email">
            </div>

            <div class="input-group mb-3">
              <span class="input-group-text"><i class="fa fa-lock color-blue"></i></span>
              <input class="form-control" placeholder="Password" name="password" type="password" autocomplete="current-password" id="sign-in-password">
            </div>

            <!-- Change this to a button or input when using this as a form -->
            <div class="d-grid gap-2">
              <button class="btn btn-lg btn-success my-2" type="button" id="modal-login-login-button">
                <div class="text-center">
                  <span id="login-wait-spinner" class="spinner-border spinner-border-sm d-none" role="status" aria-hidden="true"></span>
                    Login
                </div>
              </button>
              <button class="btn btn-default btn-sm my-2" type="button" data-bs-dismiss="modal" onclick="openSignupModal()">Create an account</button>
              <small class="text-center my-2"><a href="#" data-bs-dismiss="modal" onclick="openForgotPasswordModal();">
                Forgot password</a></small>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modal-forgot-password-form" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <h3><i class="fa fa-lock fa-3x"></i></h3>
            <h2 class="text-center">Forgot Password?</h2>

            <div id="modal-forgot-password-error" class="alert alert-danger d-none"></div>

            <div class="input-group mb-3">
              <span class="input-group-text"><i class="fa fa-envelope"></i></span>
              <input class="form-control" placeholder="you@example.com" name="email" type="email" autofocus id="forgot-password-email">
            </div>

            <div class="d-grid gap-2">
              <a href="#" class="btn btn-lg btn-success btn-block" onclick="sendForgotPasswordEmail();">
                <span id="forgot-password-wait-spinner" class="d-none"><i class="fa fa-spinner fa-spin"></i></span>Reset Password
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modal-forgot-password-email-sent" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <h3><i class="fa fa-envelope fa-3x"></i></h3>
            <h2 class="text-center">Password reset email sent.</h2>
            <p>Please check your email a reset link.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modal-verify-email" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <h3><i class="fa fa-envelope fa-2x"></i></h3>
            <h3 class="text-center">Don't forget to verify your email.</h3>
            <p>We sent you a verification link when you signed up.
              Please verify your email address by following the link we emailed to you.</p>
            <small>
              <a href="#" data-dismiss="modal" onclick="resendVerifyEmailLink();">
                <span id="resend-verify-email-wait-spinner" class="d-none"><i class="fa fa-spinner fa-spin"></i></span>
                Resend verification link
              </a>
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modal-verify-email-sent" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <h3><i class="fa fa-envelope fa-3x"></i></h3>
            <h2 class="text-center">Verification email sent.</h2>
            <p>Please check your email for the link.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modal-logout-form" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
          <h2><i class="fa-solid fa-right-from-bracket" style="font-size: 3rem;"></i></h2>
            <h2 class="text-center">Sign Out</h2>
          </div>
          <div class="d-grid gap-2">
            <button class="btn btn-success" type="button" data-bs-dismiss="modal" onclick="logout();">Sign Out</button>
            <button class="btn btn-default" type="button"data-bs-dismiss="modal">Not yet</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="modal-finish-upgrade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <h2 class="mb-4">Start Your Subscription</h2>
          </div>

          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th></th>
                  <th class="text-center">
                    <h4>Basic</h4>
                  </th>
                  <th class="text-center">
                    <h4>Pro</h4>
                  </th>
                </tr>
              </thead>
              <tbody>
                ${this.makeUpgradeFeatureRow("Save Projects", "fa-save")}
                ${this.makeUpgradeFeatureRow("Print Results", "fa-print")}
                ${this.makeUpgradeFeatureRow("Multiple Spans (more than 2)", "fa-ellipsis-h")}
                ${this.makeUpgradeFeatureRow("HSS Strong and Weak Axis Analysis", "fa-arrows")}
                ${this.makeUpgradeFeatureRow("European Steel Shape Analysis", "fa-globe")}
                ${this.makeUpgradeFeatureRow("Custom Shape Analysis", "fa-user")}
                ${this.makeUpgradeFeatureRow("Multi Ply Lumber", "fa-ellipsis-h")}
                ${this.makeUpgradeFeatureRow("LVL and PSL Engineered Lumber", "fa-calculator")}
                <tr>
                  <td></td>
                  <td class="text-center">Free</td>
                  <td class="text-center">$19 monthly</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="card card-success">
            <div class="row card-body">
              <div class="col-2 text-primary">
                <h1>$19</h1>
                <p>monthly</p>
              </div>
              <div class="col-10">
                <form action="/charge" method="post" id="payment-form" role="form">
   
                  
                    <h4 class="pt-1 text-start">
                      Enter Credit or Debit Card Information to Upgrade 
                    </h4>
                  
                    <p class="text-start fw-light text-secondary">
                      Checkout Powered by Stripe
                    </p>
                  

                  <div id="card-element" class="py-3 form-control rounded-3">
                    <!-- A Stripe Element will be inserted here. -->
                  </div>

                  <!-- Used to display Element errors. -->
                  <div id="card-errors" class="text-start py-2" role="alert"></div>

                  <div id="subscribe-response-error" class="alert alert-danger d-none py-2"></div>

                  <div class="d-grid gap-2 py-2">
                    <button id="submit-payment-button" type="button" class="btn btn-success">
                      <span id="submit-payment-spinner" class="d-none"><i class="fa fa-spinner fa-spin"></i></span>
                      Submit Payment
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`

  document.getElementById('modal-login-login-button').addEventListener('click', this.login)

  }

  makeUpgradeFeatureRow(featureDescription, faIcon) {
    return String.raw`
      <tr>
        <td><i class="fa ${faIcon} fa-fw"></i> ${featureDescription}</td>
        <td class="text-center"><i class="fa fa-remove text-danger"></i></td>
        <td class="text-center"><i class="fa fa-check text-success"></i></td>
      </tr>`
  }

  login() {
    let email = document.getElementById('sign-in-email').value.trim()
    let password = document.getElementById('sign-in-password').value.trim()

    document.getElementById('login-wait-spinner').classList.remove('d-none')
    document.getElementById('modal-sign-in-error').innerHTML = ''
    document.getElementById('modal-sign-in-error').classList.add('d-none')

    firebase.auth().signInWithEmailAndPassword(email, password)
      .then(function () {
        document.getElementById('login-wait-spinner').classList.add('d-none')
        document.getElementById('modal-sign-in-error').innerHTML = ''
        bootstrap.Modal.getOrCreateInstance(document.getElementById('modal-login-form')).hide()
        // handle login logic (configuration) in app.js "auth.onAuthStateChanged"     
        document.getElementById('projects-loading-spinner').classList.remove('d-none')   
      })
      .catch((error) => {
        console.error(error)
        let errorCode = error.code
        let errorMessage = error.message

        let str = errorMessage
        if (errorCode === 'auth/missing-email') {
          str = 'Email is required.'
        }
        if (errorCode === 'auth/wrong-password') {
          str = 'Invalid password.'
        }
        if(errorCode === 'auth/user-not-found') {
          str = 'User not found.'
        }

        document.getElementById('login-wait-spinner').classList.add('d-none')
        document.getElementById('modal-sign-in-error').innerHTML = str
        document.getElementById('modal-sign-in-error').classList.remove('d-none')
      })
  }
}

customElements.define('account-dialogs', AccountDialogComponent)